export default __webpack_public_path__ + "static/media/logo-menu.97ef1f90.svg";